import React, { Component } from 'react';
import './Carousel.scss';
import Slider from 'react-slick'

class Carousel extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    };

    render() {
        const settings = this.props.settings
        return (
            <div className='carousel'>
                <Slider {...settings}>
                    {this.props.children}
                </Slider>
            </div>
        )
    }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/views/components/Carousel/index.js